// src/Redux/Projects/overviewSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosWithAuth from '../UtilsRedux/axiosWithAuth';
import { API_ROUTES } from '../Constants/apiRoutes';
import { showFeedback } from '../UI/uiFeedbackSlice';  // ⬅️ make sure path is correct

export const fetchOverview = createAsyncThunk(
  'overview/fetch',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosWithAuth.get(API_ROUTES.OVERVIEW);
      return res.data.data;
    } catch (err) {
      const message =
        err?.response?.data?.message || 'Failed to fetch overview';

      // 🔔 Global topbar popup
      dispatch(
        showFeedback({
          type: 'error',
          title: 'Could not load dashboard overview',
          message,
        })
      );

      return rejectWithValue(message);
    }
  }
);

const overviewSlice = createSlice({
  name: 'overview',
  initialState: {
    data: null,
    status: 'idle',   // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    // optional helper if you ever want to clear it on logout / project switch
    resetOverview: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (b) => {
    b
      .addCase(fetchOverview.pending, (s) => {
        s.status = 'loading';
        s.error = null;
      })
      .addCase(fetchOverview.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.data = a.payload;
      })
      .addCase(fetchOverview.rejected, (s, a) => {
        s.status = 'failed';
        s.error = a.payload;
      });
  },
});

export default overviewSlice.reducer;

export const { resetOverview } = overviewSlice.actions;

// ✅ selectors
export const selectOverview       = (s) => s.overview.data;
export const selectOverviewStatus = (s) => s.overview.status;
export const selectOverviewError  = (s) => s.overview.error;
